ready().then(function() {

    let length = 0;
    let index = 0;

    do {
        let sections = $('section.can-bg-color').eq(index).nextUntil('section:not(.can-bg-color)').addBack();
        length = sections.length;

        if(length > 1) {
            sections.filter(':nth-child(odd)').removeClass('can-bg-color');
        }

        index++;
    }

    while (length > 0);
});
